<template>
  <div
    class="mobile-product-nav-container"
    :class="{
      shown: isShow
    }"
  >
    <div class="nav__inner">
      <div class="nav__select-list-container" @click="onClicked">
        <p
          class="selected__text"
          :class="{
            actived: showSelections
          }"
        >
          {{ selectedText }}
        </p>
      </div>
      <div class="nav__type-switch-container">
        <router-link
          v-for="(bt, index) in typeNavs"
          :key="index"
          :to="{
            path: bt.link
          }"
          class="ts__item"
          :class="[$route.name === bt.sign ? 'router-link-active' : '']"
        >
          <p>{{ bt.name }}</p>
          <i
            class="line"
            :style="{
              backgroundColor: lineColor
            }"
          ></i>
        </router-link>
      </div>
    </div>
    <transition
      name="mobileProductTopNav"
      @before-enter="onBeforeAfter"
      @enter="onEnter"
      @leave="onLeave"
    >
      <div class="select__options" v-if="showSelections">
        <div class="options__inner">
          <router-link
            tag="p"
            class="option__item"
            v-for="(option, index) in otherOpitions"
            :key="index"
            :to="{
              path: `/products/${$route.name === 'project-list-type-row' ? 'row' : 'img'}/${
                option.name.en
              }/${option.id}`
            }"
          >
            {{ option.name.en }}
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import randomColor from '@/utils/common';

export default {
  name: 'c_product-top-nav',
  props: ['typeNavs', 'navs'],
  data() {
    return {
      showSelections: false,
      isTriggerScroll: false,
      isShow: false,
    };
  },
  watch: {
    $route: {
      handler() {
        this.showSelections = false;
      },
      immediate: true,
    },
    typeNavs(val) {
      console.log(val);
    },
  },
  computed: {
    lineColor() {
      return randomColor();
    },
    otherOpitions() {
      const options = this.navs.filter((item) => item.name.en !== this.selectedText);
      return options;
    },
    compareBottom() {
      const obj = document.querySelector('.product-nav-container');
      if (obj) {
        return obj.getBoundingClientRect().bottom;
      }
      return 100;
    },
    selectedText() {
      if (this.navs.length > 0) {
        const type = this.$route.params.type === undefined ? this.navs['0'].id : this.$route.params.type;
        const nav = this.navs.find((item) => Number(item.id) === Number(type));
        if (nav) {
          return nav.name.en;
        }
        return this.navs['0'].name.en;
      }
      return '';
    },
  },
  mounted() {
    const that = this;
    that.$nextTick(() => {
      window.addEventListener('scroll', that.onScroll);
    });
  },
  methods: {
    onClicked() {
      this.showSelections = !this.showSelections;
    },
    onBeforeAfter(el) {
      el.style.height = 0;
    },
    onEnter(el, done) {
      const height = Math.ceil(el.querySelector('.options__inner').getBoundingClientRect().height);
      el.style.cssText = `height:${height}px;transition: height .3s`;
      done();
    },
    onLeave(el, done) {
      el.style.cssText = 'height:0px;transition: height .3s';
      setTimeout(() => {
        done();
      }, 300);
    },
    onSelected(name) {
      this.selectedText = name;
      this.showSelections = false;
    },
    onScroll() {
      this.isTriggerScroll = true;
      // eslint-disable-next-line max-len
      const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
      this.isShow = scrollTop >= this.compareBottom;
    },
  },
};
</script>

<style></style>
